import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,

  headers: {
    Accept: "application/json",
  },
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default instance;
